module.exports = __webpack_public_path__ + "img/login-top-img.a1b77ea.png";